
<template>
  <v-text-field
    v-model="email"
    :rules="[rules.email]"
    type="email"
    :required="required"
    @input="$emit('input', email)"
  >
    <template v-slot:label>{{ $t(label) }} </template>
  </v-text-field>
</template>

<script>
export default {
  name: 'email-input',
  props: {
    label: String,
    required: Boolean,
    value: {
      default: '',
      type: String
    }
  },

  data() {
    return {
      email: this.value,
      rules: {
        email: (v) => this.isValidEmail(v) || this.$t('hq.InvalidEmailaddress')
      }
    }
  },
  watch: {
    value(val) {
      this.email = val
    }
  }
}
</script>